/*
  وضع العرض (Demo)

  يعمل فقط عند البناء بـ REACT_APP_DEMO=true — لا أثر له في النسخة الحقيقية.
  الغرض: رابط معاينة يُظهر واجهة البرنامج كاملة دون الاتصال بالخادم.
  كل طلبات الـ API تُجاب محلياً بردود فارغة سليمة الشكل، والدخول يقبل أي
  اسم مستخدم وكلمة مرور ويفتح حساب مدير بصلاحيات كاملة.
*/
import axios from "axios";
import { handleWorkOrderDemo } from "./demoWorkOrders";

export const DEMO = process.env.REACT_APP_DEMO === "true";

const DEMO_USER = {
  id: "demo-admin",
  userId: "demo-admin",
  userName: "demo",
  displayName: "مدير النظام (عرض)",
  name: "مدير النظام (عرض)",
  email: "demo@asf.com",
  phone: "",
  userType: "admin",
  token: "demo-token",
  branchId: 1,
  branchName: "الرياض",
  officeId: 1,
  userCanCreateProjectOutsideCityType: true,
  permissions: [],
};

// رد فارغ يصلح لأغلب الأشكال: مصفوفة (‎.map/.length) تحمل أيضاً الحقول
// المعتادة (data / items / totalCount ...) فلا تنهار الصفحات أياً كان ما تقرؤه.
function emptyPayload() {
  const list = [];
  return Object.assign(list, {
    statusCode: 200,
    success: true,
    message: "",
    data: Object.assign([], { data: [], items: [], totalCount: 0 }),
    items: [],
    result: [],
    totalCount: 0,
    totalPages: 0,
    pageIndex: 1,
    pageSize: 10,
    count: 0,
  });
}

function respond(config, data, status = 200) {
  return Promise.resolve({
    data,
    status,
    statusText: "OK",
    headers: {},
    config,
    request: {},
  });
}

function demoAdapter(config) {
  const url = String(config.url || "").toLowerCase();
  if (url.includes("account/login")) {
    return respond(config, { ...DEMO_USER });
  }

  // إنشاء أمر العمل: بيانات تجريبية واقعية بدل الردود الفارغة
  const handled = handleWorkOrderDemo(
    (config.method || "get").toLowerCase(),
    String(config.url || ""),
    config.params || {},
    config.data
  );
  if (handled?.error) {
    const err = new Error(handled.error.data?.message || "demo error");
    err.response = { status: handled.error.status, data: handled.error.data, headers: {}, config };
    err.config = config;
    return Promise.reject(err);
  }
  if (handled) {
    return Promise.resolve({ data: handled.data, status: handled.status, statusText: "OK", headers: handled.headers || {}, config, request: {} });
  }

  return respond(config, emptyPayload());
}

if (DEMO) {
  axios.defaults.adapter = demoAdapter;

  // طلبات fetch المباشرة إلى الخادم (تنزيل الملفات مثلاً)
  const realFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const u = String(typeof input === "string" ? input : input?.url || "");
    if (/\/api\//i.test(u)) {
      return Promise.resolve(
        new Response(JSON.stringify(emptyPayload()), {
          status: 200,
          headers: { "Content-Type": "application/json" },
        })
      );
    }
    if (/^https?:\/\//i.test(u) && !u.startsWith(window.location.origin)) {
      // خدمات خارجية (الخرائط وتحديد العنوان) غير متاحة في المعاينة
      return Promise.resolve(new Response("{}", { status: 200 }));
    }
    return realFetch(input, init);
  };
}
